import { Button } from "@portal/ui";
import { RefreshCw } from "lucide-react";
import { ApiError } from "../api/client";

/**
 * 画面を開く途中でエラーになったときの表示(ログイン状態の確認が 500 になったときなど)。
 * これがないと、何も表示されない真っ白な画面になる(ユーザー報告 2026-10-08)。
 */
export function RouteError({ error, reset }: { error: unknown; reset?: () => void }) {
  const detail =
    error instanceof ApiError
      ? `${error.status} ${error.message}`
      : error instanceof Error
        ? error.message
        : String(error);
  return (
    <div
      role="alert"
      className="mx-auto flex max-w-lg flex-col gap-4 p-8"
      data-testid="route-error"
    >
      <h1 className="text-lg font-semibold">画面を開けませんでした</h1>
      <p className="text-sm text-muted-foreground">
        サーバーでエラーが発生しました。しばらくしてから、もう一度開いてください。続くときは、管理者に連絡してください。
      </p>
      <p className="border bg-muted px-3 py-2 text-xs break-all text-muted-foreground">{detail}</p>
      <div>
        <Button
          onClick={() => {
            reset?.();
            window.location.reload();
          }}
        >
          <RefreshCw />
          再読み込み
        </Button>
      </div>
    </div>
  );
}

/** 画面を開く途中の待ち時間の表示(何も出ない真っ白な時間を作らない)。 */
export function RoutePending() {
  return (
    <p role="status" className="p-8 text-sm text-muted-foreground">
      読み込み中…
    </p>
  );
}
